// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ntable, th, td {\n  border: 1px solid black;\n  border-collapse: collapse;\n  border-spacing: 5px;\n}\n.grecaptcha-badge{ \n    visibility: hidden;\n}\n@media print {\nhtml, body {\n        height: 99%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
